/**
 * Class names for Delimiter
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleDelimiterClasses {

    /**
     * Class name to specify this delimiter is before an entity
     */
    DELIMITER_BEFORE = 'entityDelimiterBefore',

    /**
     *  Class name to specify this delimiter is after an entity
     */
    DELIMITER_AFTER = 'entityDelimiterAfter',
}
